import { CalendarEvent } from 'owa-calendar-types';
import { isEqual } from 'owa-datetime';

/**
 * Reports any event(s) that start at the same time as the specified "up-next" event (if any),
 * not including the "up-next" event itself.
 *
 * @param upNextEvent - event marked as up-next
 * @param events - list of events to consider
 * @returns list of events that should be considered conflicts of the up-next event
 */
export function getUpNextEventConflicts(
    upNextEvent: CalendarEvent,
    events: CalendarEvent[]
): CalendarEvent[] {
    return events.filter(
        event =>
            event.ItemId.Id !== upNextEvent.ItemId.Id && isEqual(event.Start, upNextEvent.Start)
    );
}
